import getByIdReduxSelector from '../../../../redux/selectors/get-by-id'
import WORKOUT_EXERCISES_PATH from '../../constants/path'

function getByIdWorkoutExerciseSelector (id) {
  return (state) => {
    return getByIdReduxSelector(WORKOUT_EXERCISES_PATH.DATA, id)(state)
  }
}

export default getByIdWorkoutExerciseSelector
